import {AbstractDialogOperation, IParams} from "./AbstractDialogOperation";
import {MAX_RESULTS_PER_PAGE, SPINNER} from "../../../constants";
import {global} from "../../../appContext";
import pubsub from "../../../pubsub";
import PromiseRequest from "../../../req/PromiseRequest";
import {TServiceName} from "../../../constants/ApiServices";
import {PLEASE_WAIT_MESSAGE} from "../../../constants/Language";
import purgeHtml from './purge.html?raw';

export let template: string = purgeHtml;

export class viewModel extends AbstractDialogOperation {

    constructor(params: IParams) {
        super((() => {
            params.searchObjectParams.onlyids = true;
            params.searchObjectParams.resultsprpage = MAX_RESULTS_PER_PAGE;
            return params;
        })());
    }

    protected serviceName: TServiceName = "purgeobject";

    protected override readonly maxConcurrentRequests = 1

    protected override onProcessComplete() {
        this.messageData({message: PLEASE_WAIT_MESSAGE});
        new PromiseRequest("emptycache")
            .request()
            .then(() => {
                global.cacheManager.removeCache("getobject");
                global.cacheManager.removeCache("searchobject");
                this.params.data([])
                pubsub.trigger("search.object.needs.refresh");
                this.step(this.Step.Complete);
            });
    }

    protected getProcessItemSuccessMessage(): string {
        return `((deleting|td)) [${this.submitSuccess.length + this.submitError.length}/${this.numTotal}] ${SPINNER}`;
    }

    protected successMessage(): string {
        const n = this.submitSuccess.length
        return `subject is deleted|n:${n}|s:${this.getNumObjectsLabel(n)}`
    }

    protected errorMessage(): string {
        const n = this.submitError.length
        return `subject is not deleted due to error|n:${n}|s:${this.getNumObjectsLabel(n)}`
    }

}
